module.exports = __webpack_public_path__ + "static/img/two-tip.35f6904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/two-tip.png
// module id = PZJg
// module chunks = 156